import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-virtual-product-label',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span
      class="text-green-500 border border-green-500 rounded-md px-1 text-xs uppercase font-bold"
      >Virtual</span
    >
  `
})
export class VirtualProductLabelComponent {}
